import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./DepositUpi.css";
import { RiArrowRightSLine, RiArrowDownSLine } from "react-icons/ri";
import ManualDepositPopup from "./ManualDepositPopup";
import OnlineDeposit from "./OnlineDeposit";
import UpiGetway from "./UpiGetway";
import WithdrawManual from "./WithdrawManual";
import WithdrawBank from "./WithdrawBank";
import Storage from "../../../Storage";
import { API } from "../../../Helper";
import axios from "axios";
import WithdrawOnline from "./WithdrawOnline";

function DepositUpi({ style, children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Deposit");
  const [showDropdowns, setShowDropdowns] = useState({});
  const [popupVisible, setPopupVisible] = useState(false);
  const [onlineDepositVisible, setOnlineDepositVisible] = useState(false);
  const [upiGatewayVisible, setUpiGatewayVisible] = useState(true);
  const [withdrawManualVisible, setWithdrawManualVisible] = useState(false);
  const [withdrawOnlineVisible, setWithdrawOnlineVisible] = useState(true);
  const [withdrawBankVisible, setWithdrawBankVisible] = useState(false);

  const [showDropdown, setShowDropdown] = useState(null);

  const toggleDropdown = (key) => {
    setShowDropdown((prev) => (prev === key ? null : key));
  };

  const handlePopupToggle = () => {
    setPopupVisible(!popupVisible);
  };

  const handleOnlineDepositToggle = () => {
    setOnlineDepositVisible(!onlineDepositVisible);
  };

  const handleUpiGatewayToggle = () => {
    setUpiGatewayVisible(!upiGatewayVisible);
  };

  const handleWithdrawManualToggle = () => {
    setWithdrawManualVisible(!withdrawManualVisible);
  };

  const handleWithdrawOnlineToggle = () => {
    setWithdrawOnlineVisible(!withdrawOnlineVisible);
  };

  const handleWithdrawBankToggle = () => {
    setWithdrawBankVisible(!withdrawBankVisible);
  };


  const [items, setItems] = useState([]);

  const fetchItems = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/admin/getWalletCurrency`);
      if (res.data.status) {
        setItems(res.data.data);
      } else {
        toast(res.data.message);
      }
    } catch (err) {
      toast("Error fetching wallet currencies.");
    }
  }, []);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);


  const selectedCurrency = Storage?.getKey("currency"); // "USD", "PKR", etc.

  const selectedCurrencyData = useMemo(() => {
    return items.find(
      (item) => item?.currency_code === selectedCurrency
    );
  }, [items, selectedCurrency]);


  return (
    <div>
      <button style={style} onClick={() => {
        setIsOpen(true);
        if (window.fbq) {
          window.fbq('track', 'AddToCart');
        }
      }}>
        {children}
      </button>
      {isOpen && (
        <div className="popup-main-container-inner">
          <div className="popup-main-container">
            <div className="popup-inner-box">
              <div
                className="vip2-popup-page"
                style={{ background: "#323738" }}
              >
                <div
                  className="vip2-popup-page-btn"
                  onClick={() => setIsOpen(false)}
                >
                  X
                </div>
                Deposit
              </div>
              <div
                className="popup-tabs-wrapper"
                style={{ background: "#323738" }}
              >
                <span
                  className={`popup-tab-option ${activeTab === "Deposit" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("Deposit")}
                >
                  Deposit
                </span>
                <span
                  className={`popup-tab-option ${activeTab === "Withdraw" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("Withdraw")}
                >
                  Withdraw
                </span>
              </div>
              {activeTab === "Deposit" && (
                <UpiGetway
                  isOpen={upiGatewayVisible}
                  onClose={() => setUpiGatewayVisible(false)} // Close UPI Gateway Popup
                  data={selectedCurrencyData}
                />

              )}
              {activeTab === "Withdraw" && (
                <WithdrawOnline
                  isOpen={withdrawOnlineVisible}
                  onClose={() => setWithdrawOnlineVisible(false)} // Close Withdraw Online Popup
                />
              )}
            </div>
          </div>
        </div>
      )}
      {/* Popups */}
      <ManualDepositPopup
        isOpen={popupVisible}
        onClose={() => setPopupVisible(false)} // Close Manual Deposit Popup
      />
      <OnlineDeposit
        isOpen={onlineDepositVisible}
        onClose={() => setOnlineDepositVisible(false)} // Close Online Deposit Popup
      />

      {/* <WithdrawManual
        isOpen={withdrawManualVisible}
        onClose={() => setWithdrawManualVisible(false)} // Close Withdraw Manual Popup
      /> */}

      <WithdrawBank
        isOpen={withdrawBankVisible}
        onClose={() => setWithdrawBankVisible(false)} // Close Withdraw Bank Popup
      />
    </div>
  );
}

export default DepositUpi;
